import { Table, TableBody, TableCell, TableContainer, TableProps, TableRow, Typography, useTheme } from '@mui/material';
import LoadingSpinner from 'components/loading-spinner';
import React from 'react';

type Props = TableProps & {
  noResult?: {
    show: boolean;
    text: string | React.ReactNode;
  };
  isLoading?: boolean;
};

const NewList: React.FC<Props> = ({ noResult, isLoading, children, ...props }) => {
  const theme = useTheme();

  return isLoading ? (
    <TableContainer>
      <Table
        {...props}
        sx={{
          marginBottom: 2,
        }}>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: 'white',
                borderRadius: 2.5,
              }}>
              <LoadingSpinner />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : noResult?.show ? (
    <TableContainer>
      <Table
        sx={{
          marginBottom: 2,
        }}
        {...props}>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: 'white',
                borderRadius: 2.5,
              }}>
              <Typography fontWeight={500} textAlign={'center'} color={theme.palette.darkBlue.main}>
                {noResult.text}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <TableContainer>
      <Table {...props}>{children}</Table>
    </TableContainer>
  );
};

export default React.memo(NewList);
